// Small relative-time helper for "N s/m/h ago" labels on cached data.
// tsSeconds accepts a Unix epoch (seconds). null/undefined renders "never".

export function formatRelativeTime(tsSeconds) {
  if (tsSeconds === null || tsSeconds === undefined) return "never";
  const nowSec = Math.floor(Date.now() / 1000);
  const diff = Math.max(nowSec - Math.floor(tsSeconds), 0);

  if (diff < 5) return "just now";
  if (diff < 60) return `${diff}s ago`;
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  return `${Math.floor(diff / 86400)}d ago`;
}
